'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transactSubscriptions = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildSubscribeOptions = function buildSubscribeOptions(channel, playbackMessagesFrom) {
  return {
    channels: [channel],
    playbackMessagesFrom: playbackMessagesFrom
  };
};

var buildUnsubscribeOptions = function buildUnsubscribeOptions(channel) {
  return {
    channels: [channel]
  };
};

var hasChange = function hasChange(changeSet) {
  return Boolean(Object.keys(changeSet).length);
};

/**
 * Unsubscribe and subscribe in a transaction
 *
 * @param {Object} options
 * @param {Object} options.vendor vendor api wrapper
 * @param {Object<channelId, messageCallback>} options.toAdd subscriptions to add
 * @param {Object<channelId, messageCallback>} options.toRemove subscriptions to remove
 *
 * @returns {Promise}
 *
 */
var transactSubscriptions = exports.transactSubscriptions = function transactSubscriptions(_ref) {
  var vendor = _ref.vendor,
      _ref$toAdd = _ref.toAdd,
      toAdd = _ref$toAdd === undefined ? {} : _ref$toAdd,
      _ref$toRemove = _ref.toRemove,
      toRemove = _ref$toRemove === undefined ? {} : _ref$toRemove,
      playbackMessagesFrom = _ref.playbackMessagesFrom;

  return _q2.default.Promise.all(Object.keys(toRemove).map(function (channel) {
    return vendor.unsubscribe(buildUnsubscribeOptions(channel), toRemove[channel]);
  }))
  /* ABLY TODO: Remove call to reauthorize when wildcard auth is supported */
  .then(function () {
    return hasChange(toAdd) && vendor.reauthorize(Object.keys(toAdd));
  }).then(function () {
    return _q2.default.Promise.all(Object.keys(toAdd).map(function (channel) {
      return vendor.subscribe(buildSubscribeOptions(channel, playbackMessagesFrom), toAdd[channel]);
    }));
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/conversations-pub-sub/client/transactSubscriptions.js
// module id = 411
// module chunks = 2 3